import { ofType } from "redux-observable";
import { combineLatest, EMPTY, merge, of } from "rxjs";
import { delay, switchMap } from "rxjs/operators";
import { selectBalancingSpecialOffersIds } from "../../../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { selectGrowthFundCharacteristicIds } from "../../../selectors/selectShopInfo";
import { TypeActionBalancing } from "../../balancing/actionBalancing";
import { actionRequestPaymentEntryInfo } from "../../info/payment-entry-info/actionPaymentEntryInfo";
import { TypeActionShop } from "../actionShop";
export var epicShopPaymentEntryRequest = function (action$, state$, deps) {
    var characteristicsReceived$action$ = action$.pipe(ofType(TypeActionShop.CharacteristicsReceived));
    var balancingRegister$ = action$.pipe(ofType(TypeActionBalancing.Registered));
    var shiftLevelReceived$ = action$.pipe(ofType(TypeActionShop.ShiftLevelReceived));
    var firstRequest$ = combineLatest(balancingRegister$, characteristicsReceived$action$);
    return merge(firstRequest$, shiftLevelReceived$).pipe(delay(1), switchMap(function () {
        var growsFundIds = selectGrowthFundCharacteristicIds(state$.value);
        var specialOfferIds = selectBalancingSpecialOffersIds();
        return growsFundIds.length > 0 || specialOfferIds.length > 0
            ? of(actionRequestPaymentEntryInfo(growsFundIds.concat(specialOfferIds)))
            : EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopPaymentEntryRequest.ts
// module id = 2340
// module chunks = 3